// remove-express-payments.js
(function(){
  function removeSelectors(){
    var sel = [
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      '.additional-checkout-buttons',
      '.dynamic-checkout__content',
      '.dynamic-checkout__button',
      '.button--shop-pay',
      '.button--paypal',
      '.paypal-button',
      '.apple-pay-button',
      '.gpay-button',
      '.shop-pay-button',
      '[data-provider="paypal"]',
      '[data-payment-provider*="paypal"]'
    ];
    sel.forEach(function(s){
      document.querySelectorAll(s).forEach(function(el){ try{ el.remove(); }catch(e){ el.style.display='none'; }});
    });

    // Remove any element whose visible text contains payment provider names
    var texts = ['paypal','shop pay','shopify pay','google pay','g pay','apple pay','amazon pay'];
    document.querySelectorAll('button, a, div, span').forEach(function(el){
      if(!el || !el.innerText) return;
      var txt = el.innerText.toLowerCase().trim();
      for(var i=0;i<texts.length;i++){
        if(txt.indexOf(texts[i]) !== -1){
          try{ el.remove(); } catch(e){ el.style.display='none'; }
          break;
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    removeSelectors();
    // retry a few times in case elements are injected asynchronously
    setTimeout(removeSelectors, 500);
    setTimeout(removeSelectors, 1200);
    // observe dynamic changes
    var observerRoot = document.body;
    var mo = new MutationObserver(function(){
      removeSelectors();
    });
    mo.observe(observerRoot, { childList: true, subtree: true });
  });
})();
